import type { ActionArtifact, DrawnCard, Reading, Scenario, SessionInfo, VentRitualResult } from "../types";

const TOKEN_KEY = "career_tarot_session";

export function readToken() {
  return localStorage.getItem(TOKEN_KEY) ?? "";
}

export function saveToken(token: string) {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

async function request<T>(path: string, init: RequestInit = {}): Promise<T> {
  const token = readToken();
  const response = await fetch(`/api${path}`, {
    ...init,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...init.headers,
    },
  });
  const data = (await response.json().catch(() => ({}))) as T & { message?: string };
  if (!response.ok) throw new Error(data.message || "请求失败，请稍后再试");
  return data;
}

export const api = {
  activate: (code: string) =>
    request<SessionInfo & { success: true; message: string }>("/activate", {
      method: "POST",
      body: JSON.stringify({ code }),
    }),
  session: () => request<Omit<SessionInfo, "token"> & { success: true }>("/session"),
  startDraw: (spread: "career" | "direction" = "career") =>
    request<{ success: true; drawId: string; slotCount: number; expiresIn: number }>("/draw/start", {
      method: "POST",
      body: JSON.stringify({ spread }),
    }),
  selectCards: (drawId: string, slots: number[]) =>
    request<{ success: true; cards: DrawnCard[] }>("/draw/select", {
      method: "POST",
      body: JSON.stringify({ drawId, slots }),
    }),
  report: (payload: { drawId: string; scenario: Scenario; question: string; context: string; horizon: string; cards: DrawnCard[] }) =>
    request<{ success: true; report: Reading; quotaLeft: number; modelUsed: string }>("/report", {
      method: "POST",
      body: JSON.stringify(payload),
    }),
  actionPlan: (payload: { drawId: string; scenario: Scenario; question: string; context: string; cards: DrawnCard[]; report: Reading; artifactType: string }) =>
    request<{ success: true; artifact: ActionArtifact; quotaLeft: number; modelUsed: string }>("/action-plan", {
      method: "POST",
      body: JSON.stringify(payload),
    }),
  ventRitual: (payload: { target: string; behaviors: string[]; vent: string }) =>
    request<{ success: true; ritual: VentRitualResult; quotaLeft: number; modelUsed: string }>("/vent-ritual", {
      method: "POST",
      body: JSON.stringify(payload),
    }),
};
